import {
  _COMMIT_LOG, _PROCESS_ERROR, USER_GET_USERS, USER_SET_STAFF,
} from './actions.types'
import {
  USER_SET_USERS, USER_SET_UPDATE_ERRORS,
} from './mutations.types'
import ApiService from '../services/api.service'

const initialState = {
  users: [],
  errors: [],
  updateErrors: [],
}

export const state = { ...initialState }

export const actions = {

  /***
   * Get Users
   * @param {string} payload.fk_organization_key rowkey of the organization you want to find users for, blank if all.
   * @returns {*}
   */
  async [USER_GET_USERS] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Getting users')
      const response = await ApiService.query('user', {
        ...payload,
      })
      dispatch(_COMMIT_LOG, ['Get Users response: ', response.data])
      commit(USER_SET_USERS, response.data)
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      dispatch(_COMMIT_LOG, ['processedErrorData', processedError])
      let errors = ['Error while posting payment.']
      if (processedError && processedError.problems && processedError.problems.length > 0) {
        errors = processedError.problems
      } else if (processedError && processedError.display_text && processedError.display_text.length > 0) {
        errors = [processedError.display_text]
      }
      commit(USER_SET_USERS, [])
      dispatch(_COMMIT_LOG, errors)
      return false
    }
  },
  /***
   * Set Staff
   * @param {string} payload.rowkey rowkey of the user to set-staff status for
   * @param {boolean} payload.is_staff boolean to set staff status or not.
   * @returns {*}
   */
  async [USER_SET_STAFF] ({ dispatch, commit, rootState }, payload) {
    if (!payload || !payload.rowkey) {
      commit(USER_SET_UPDATE_ERRORS, ['All paramaters are required to set staff status'])
      throw new Error('All paramaters are required to set staff status')
    }
    commit(USER_SET_UPDATE_ERRORS, [])
    try {
      console.log('Setting user staff status')
      const response = await ApiService.postAction('user', `${payload.rowkey}`, 'set-staff', {
        ...payload,
      })
      dispatch(_COMMIT_LOG, ['Set user staff status response: ', response.data])
      // commit(USER_SET_USERS, response.data)
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      dispatch(_COMMIT_LOG, ['processedErrorData', processedError])
      let errors = ['Error while updating user staff status.']
      if (processedError && processedError.problems && processedError.problems.length > 0) {
        errors = processedError.problems
      } else if (processedError && processedError.display_text && processedError.display_text.length > 0) {
        errors = [processedError.display_text]
      }
      commit(USER_SET_UPDATE_ERRORS, errors)
      dispatch(_COMMIT_LOG, errors)
      return false
    }
  },
}

export const mutations = {
  [USER_SET_USERS] (state, data) {
    state.users = data
  },
  [USER_SET_UPDATE_ERRORS] (state, data) {
    state.updateErrors = data
  },
}
export const getters = {
  users: state => state.users,
  userUpdateErrors: state => state.updateErrors,
}

export default {
  state,
  actions,
  mutations,
  getters,
}
